import { render, staticRenderFns } from "./BrigadeFutur3.vue?vue&type=template&id=1f441d07&scoped=true&"
import script from "./BrigadeFutur3.vue?vue&type=script&lang=js&"
export * from "./BrigadeFutur3.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeFutur3.vue?vue&type=style&index=0&id=1f441d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f441d07",
  null
  
)

export default component.exports